'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



//////////////////
// WEBPACK FOOTER
// ../node_modules/querystring-es3/index.js
// module id = 632
// module chunks = 0